import React from "react";
import { ExamPaperInfo, ExamSettings } from "../../../API";

interface ExamContextProps {
    isExam: boolean; // 因为作业和考试的代码混在在一起, 所以加了这个字段, 用来区分一下. 我知道这样做很屎, 但我想不到更好的办法了
    examId: string;
    examInfo?: ExamPaperInfo;
    examSettings?: ExamSettings | null;
    handleSwitchScreen: (count: number) => void;
    handleDownload: (fileUrl: string) => void;
}

export const ExamContext = React.createContext<ExamContextProps>({
    isExam: false, // 默认是作业, 请不要改这个值, 因为作业使用默认值
    examId: "",
    handleSwitchScreen: () => null,
    handleDownload: () => null
});
